<template>
    <div class="sk-spin"
        :class="{
            'sk-spin-white':color == 'white'
        }">


        <div class="sk-wave" :style="{
                width: `${px}px`,
                height: `${px}px`,
            }">
            <div class="sk-wave-rect"></div>
            <div class="sk-wave-rect"></div>
            <div class="sk-wave-rect"></div>
            <div class="sk-wave-rect"></div>
            <div class="sk-wave-rect"></div>
        </div>
    </div>
</template>

<script>
    export default {
        props:{
            px: Number,
            color: {
                type:String,
                required: false,
            }
        },
    }
</script>

<style>
    .sk-spin{
        --sk-color:#4299E1;
    }
    .sk-spin-white{
        --sk-color:#FFF;
    }
</style>
